var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{staticClass:"contacts",staticStyle:{"width":"100%"},attrs:{"name":_vm.name,"id":_vm.name,"placeholder":_vm.placeholder,"disabled":_vm.disabled}})}
var staticRenderFns = []

export { render, staticRenderFns }